import { CREATE_BOOKING, CREATE_BOOKING_SUCCESS, CREATE_BOOKING_ERROR, CREATE_BOOKING_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateBooking = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BOOKING:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_BOOKING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_BOOKING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_BOOKING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateBooking;
